import { ArrowRightOutlined, UserOutlined, StopOutlined, CheckOutlined, GroupOutlined, UnorderedListOutlined, CustomerServiceOutlined, RobotOutlined, AppstoreOutlined, SwapOutlined, CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import { Alert, Col, Empty, message, PageHeader, Popconfirm, Row, Select, Space, Spin, Table, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, CheckItem, ModalItem, SegmentedItem, SelectItem, TableItemDinamico, Form, FormItem, DatePickerItem, InputNumberItem, TabbedDynamicTable } from "../../../Components/Items";
import { nombreDeUsuario } from "../../Panel/Soporte/Chat/nombreUsuario";
import ModalPaquetesIa from "./ModalPaquetesIa";
import CatalogoCobro from "./CobroBiwo/CatalogoCobro";
import MastersCobro from "./CobroBiwo/MastersCobro";
import CobranzaCobro from "./CobroBiwo/CobranzaCobro";
import ResumenCobro from "./CobroBiwo/ResumenCobro";
import ConfiguracionCobro from "./CobroBiwo/ConfiguracionCobro";
import ModalComplementosEmpresa from "./CobroBiwo/ModalComplementosEmpresa";
import AgregarEmpresa from "../Empresas/AgregarEmpresa/AgregarEmpresa";
import AgregarEmpresaBasica from "../Empresas/AgregarEmpresaBasica/AgregarEmpresaBasica";
import AgregarEmpresaBasica2 from "../Empresas/AgregarEmpresaBasica2/AgregarEmpresaBasica2";
import { textoLimitesPaquete, textoPrecioPaquete } from "../IA/paqueteIaTextos";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class EmpresasBiwo extends Component {
    tableRef = null;
    formRefVencimiento = React.createRef();
    formRefUsuariosContadores = React.createRef();
    state = {
        todasEmpresasBiwo: [],
        loading: false,
        valor: 4,
        initialValueContadores: null,
        initialValueUsuarios: null,
        initialValueFechaVencimiento: null,
        vistaAgrupada: false,
        datosAgrupados: [],
        modalAccesoSoporteVisible: false,
        empresaAccesoSoporteNombre: "",
        usuariosAccesoSoporte: [],
        idsAccesoSoporte: [],
        loadingAccesoSoporte: false,
        modalPaquetesIaVisible: false,
        modalPaqueteEmpresaVisible: false,
        empresaPaquete: null,
        paquetesIaActivos: [],
        paqueteIaSeleccionado: undefined,
        empresaComplementos: null,
        modalAgregarEmpresa: null,
        mastersBiwo: [],
        pestana: this.props.location?.state?.pestana || "empresas",
    };
    consultarEmpresasBiwo(params) {
        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/selectTodasEmpresasBiwo",
                { ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasEmpresasBiwo: [] });
                } else {
                    this.setState({
                        todasEmpresasBiwo: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarEmpresa = (id) => {
        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/deshabilitarEmpresa",
                { empresaId: id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Empresa deshabilitada");
                    this.refreshTable();
                } else {
                    message.error("Error al deshabilitar la empresa");
                }
            });
    }

    rehabilitarEmpresa = (id) => {
        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/rehabilitarEmpresa",
                { empresaId: id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Empresa rehabilitada");
                    this.refreshTable();
                } else {
                    message.error("Error al rehabilitar la empresa");
                }
            });
    }

    cambiarIaEmpresa = (id, claude, paqueteIaId) => {
        this.setState({ loading: true });
        return axios
            .post(
                "empresasBiwo/cambiarIaEmpresa",
                { empresaId: id, claude, paqueteIaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(claude ? "IA activada" : "IA desactivada");
                    this.refreshTable();
                    return true;
                }
                message.error(res.data.message || "Error al cambiar la IA de la empresa");
                return false;
            });
    }

    abrirPaqueteEmpresa = (record) => {
        this.setState({
            modalPaqueteEmpresaVisible: true,
            empresaPaquete: record,
            paqueteIaSeleccionado: record.paqueteIaId || undefined,
            paquetesIaActivos: [],
        });
        axios
            .post("empresasBiwo/selectPaquetesIa", { soloActivos: true }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({ paquetesIaActivos: res.data.data });
                } else {
                    message.error(res.data.message || "Error al consultar los paquetes de IA");
                }
            });
    }

    cerrarPaqueteEmpresa = () => {
        this.setState({ modalPaqueteEmpresaVisible: false, empresaPaquete: null, paqueteIaSeleccionado: undefined });
    }

    confirmarPaqueteEmpresa = async () => {
        const empresa = this.state.empresaPaquete;
        const paqueteIaId = this.state.paqueteIaSeleccionado;
        if (!paqueteIaId) return message.warning("Selecciona un paquete de IA");

        if (!empresa.claude) {
            if (await this.cambiarIaEmpresa(empresa._id, true, paqueteIaId)) this.cerrarPaqueteEmpresa();
            return;
        }

        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/cambiarPaqueteIaEmpresa",
                { empresaId: empresa._id, paqueteIaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Paquete de IA actualizado");
                    this.cerrarPaqueteEmpresa();
                    this.refreshTable();
                } else {
                    message.error(res.data.message || "Error al cambiar el paquete de IA");
                }
            });
    }

    refreshTable = () => {
        if (this.state.vistaAgrupada) {
            this.fetchGruposAgrupados();
        } else if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
    }

    fetchGruposAgrupados = () => {
        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/selectTodasEmpresasBiwo",
                { valor: this.state.valor, agrupadoPorCorporativo: true },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2 && res.data.agrupado) {
                    this.setState({ datosAgrupados: res.data.data });
                } else {
                    this.setState({ datosAgrupados: [] });
                }
            });
    }

    toggleVistaAgrupada = () => {
        const nuevaVista = !this.state.vistaAgrupada;
        this.setState({ vistaAgrupada: nuevaVista }, () => {
            if (nuevaVista) {
                this.fetchGruposAgrupados();
            }
        });
    }

    adelantar1MesFechaVencimiento = (value) => {
        this.setState({ loading: true });
        axios
            .post(
                "empresasBiwo/adelantarVencimiento1Mes",
                { empresaId: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Fecha de bloqueo adelantada 1 mes");
                    this.refreshTable();
                } else {
                    message.error("Error al adelantar fecha de bloqueo");
                }
            });
    }

    cambiarFechaVencimientoEmpresa(value, fechaVencimiento) {
        this.setState({
            modalCambiarFechaVencimientoVisible: true,
            empresaSeleccionadaId: value,
            initialValueFechaVencimiento: moment(fechaVencimiento),
        })
    }

    cerrarModalCambiarFechaVencimiento = () => {
        this.setState({
            modalCambiarFechaVencimientoVisible: false,
            empresaSeleccionadaId: null,
        })
    }

    cambiarUsuariosContadoresEmpresa(value, usuarios, contadores) {
        this.setState({
            modalCambiarUsuariosContadoresVisible: true,
            empresaSeleccionadaId: value,
            initialValueContadores: contadores,
            initialValueUsuarios: usuarios,
        })
    }

    cerrarModalCambiarUsuariosContadores = () => {
        this.setState({
            modalCambiarUsuariosContadoresVisible: false,
            empresaSeleccionadaId: null,
        })
    }

    confirmarCambiarUsuariosContadores = () => {
        this.formRefUsuariosContadores.current.validateFields().then((values) => {
            this.setState({ loading: true });
            axios
                .post(
                    "empresasBiwo/cambiarUsuariosContadores",
                    { empresaId: this.state.empresaSeleccionadaId, ...values },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    if (res.data.success === 2) {
                        message.success("Usuarios y contadores actualizados");
                        this.cerrarModalCambiarUsuariosContadores();
                        this.refreshTable();
                    } else {
                        message.error("Error al actualizar usuarios y contadores");
                    }
                });
        });
    }

    abrirAccesoSoporte = (record) => {
        this.setState({
            modalAccesoSoporteVisible: true,
            empresaSeleccionadaId: record._id,
            empresaAccesoSoporteNombre: record.nombreCompleto || record.nombre,
            usuariosAccesoSoporte: [],
            idsAccesoSoporte: [],
            loadingAccesoSoporte: true,
        });
        axios
            .post(
                "soporte/usuariosEmpresaSoporte",
                { empresaId: record._id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loadingAccesoSoporte: false });
                if (res.data.success === 2) {
                    const usuarios = res.data.usuarios || [];
                    this.setState({
                        usuariosAccesoSoporte: usuarios,
                        idsAccesoSoporte: usuarios
                            .filter((u) => u.tipo !== 0 && u.puedeAutorizarSoporte)
                            .map((u) => u._id.toString()),
                    });
                } else {
                    message.error(res.data.message || "Error al obtener los usuarios de la empresa");
                }
            })
            .catch(() => {
                this.setState({ loadingAccesoSoporte: false });
                message.error("Error de red al obtener los usuarios de la empresa");
            });
    }

    cerrarAccesoSoporte = () => {
        this.setState({
            modalAccesoSoporteVisible: false,
            empresaSeleccionadaId: null,
            usuariosAccesoSoporte: [],
            idsAccesoSoporte: [],
        });
    }

    cambiarAccesoSoporte = (usuarioId, habilitado) => {
        this.setState((prev) => ({
            idsAccesoSoporte: habilitado
                ? [...prev.idsAccesoSoporte, usuarioId]
                : prev.idsAccesoSoporte.filter((id) => id !== usuarioId),
        }));
    }

    marcarTodosAccesoSoporte = (habilitados) => {
        this.setState((prev) => ({
            idsAccesoSoporte: habilitados
                ? prev.usuariosAccesoSoporte.filter((u) => u.tipo !== 0).map((u) => u._id.toString())
                : [],
        }));
    }

    confirmarAccesoSoporte = () => {
        this.setState({ loadingAccesoSoporte: true });
        axios
            .post(
                "soporte/actualizarAccesoSoporte",
                {
                    empresaId: this.state.empresaSeleccionadaId,
                    usuariosPermitidos: this.state.idsAccesoSoporte,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loadingAccesoSoporte: false });
                if (res.data.success === 2) {
                    message.success("Quién autoriza soporte quedó actualizado");
                    this.cerrarAccesoSoporte();
                } else {
                    message.error(res.data.message || "Error al actualizar quién autoriza soporte");
                }
            })
            .catch(() => {
                this.setState({ loadingAccesoSoporte: false });
                message.error("Error de red al actualizar quién autoriza soporte");
            });
    }

    confirmarCambiarFechaVencimiento = () => {
        this.formRefVencimiento.current.validateFields().then((values) => {
            this.setState({ loading: true });
            axios
                .post(
                    "empresasBiwo/adelantarVencimiento",
                    { empresaId: this.state.empresaSeleccionadaId, ...values },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    if (res.data.success === 2) {
                        message.success("Fecha de bloqueo adelantada");
                        this.cerrarModalCambiarFechaVencimiento();
                        this.refreshTable();
                    } else {
                        message.error("Error al adelantar fecha de bloqueo");
                    }
                });
        });
    }

    abrirAgregarEmpresa = (tipo) => {
        this.setState({ modalAgregarEmpresa: tipo });
        axios.post("empresasBiwo/selectMastersBiwo", {}, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) this.setState({ mastersBiwo: res.data.data });
        });
    };

    render() {
        const columns = [
            {
                title: "#",
                dataIndex: "numero",
                key: "numero",
                render: (value, record, index) => {
                    return <span>{index + 1}</span>;
                },
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                render: (_, record) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>{record.nombreCompleto}</span>
                        <span style={{ fontSize: "12px", color: "#666" }}>{moment(record.fechaVencimiento).format("LL")}</span>
                    </div>
                ),
                width: "15%",
            },
            {
                title: "RFC",
                dataIndex: "rfc",
                key: "rfc",
                buscar: "rfc",
                width: "15%",
                responsive: ["md"],
            },
            {
                title: "Corporativo",
                dataIndex: "corporativo",
                key: "corporativo",
                buscar: "corporativo",
                width: "12%",
                responsive: ["md"],
            },
            {
                title: "Creacion",
                dataIndex: "fechaCreacion",
                key: "fechaCreacion",
                sorter: true,
                render: (value) => {
                    return <span>{moment(value).format("LL")}</span>;
                },
                width: "10%",
                responsive: ["md"],
            },
            {
                title: "Fecha de bloqueo",
                dataIndex: "fechaVencimiento",
                key: "fechaVencimiento",
                sorter: true,
                render: (value, record) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span>{moment(value).format("LL")}</span>
                        {record.cicloCobro && (
                            <>
                                <span style={{ fontSize: "11px", color: "#666" }}>Emisión {moment(record.cicloCobro.emision).format("DD/MM/YYYY")}</span>
                                <span style={{ fontSize: "11px", color: "#666" }}>Corte {moment(record.cicloCobro.corte).format("DD/MM/YYYY")}</span>
                            </>
                        )}
                    </div>
                ),
                width: "10%",
                responsive: ["md"],
            },
            {
                title: "Usuarios",
                dataIndex: "usuarios",
                key: "usuarios",
                sorter: true,
                align: 'center',
                width: "5%",
            },
            {
                title: "Contadores",
                dataIndex: "contadores",
                key: "contadores",
                sorter: true,
                align: 'center',
                width: "5%",
            },
            {
                title: "IA",
                dataIndex: "paqueteIaNombre",
                key: "paqueteIaNombre",
                width: "8%",
                responsive: ["md"],
                render: (value, record) => {
                    if (!record.claude) return null;
                    return value ? <Tag color="purple">{value}</Tag> : <Tag color="red">Sin paquete</Tag>;
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "5%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return <Tag color="blue">Desconocido</Tag>;
                },
            },
        ];

        const accion = ({ key, texto, icon, paleta, onClick, confirmar }) => {
            const boton = (
                <ButtonItem key={key} type="default" size="small" {...{ [paleta]: true }} icon={icon} onClick={confirmar ? undefined : onClick}>
                    {texto}
                </ButtonItem>
            );
            if (!confirmar) return boton;
            return (
                <Popconfirm key={key} title={confirmar} onConfirm={onClick} okText="Sí" cancelText="No">
                    {boton}
                </Popconfirm>
            );
        };

        const renderAcciones = (record) => {
            const nombre = record.nombreCompleto;

            if (record.estado !== 1) {
                return (
                    <div className="acciones-fila-empresa">
                        {record.estado === 0 &&
                            accion({
                                key: "rehabilitar",
                                texto: "Rehabilitar",
                                icon: <CheckOutlined />,
                                paleta: "verde",
                                onClick: () => this.rehabilitarEmpresa(record._id),
                                confirmar: "¿Estás seguro de rehabilitar " + nombre + "?",
                            })}
                    </div>
                );
            }

            return (
                <div className="acciones-fila-empresa">
                    <div className="acciones-fila-grupo">
                        {accion({
                            key: "mes",
                            texto: "+1 mes",
                            icon: <ArrowRightOutlined />,
                            paleta: "verde",
                            onClick: () => this.adelantar1MesFechaVencimiento(record._id),
                            confirmar: "¿Estás seguro de adelantar 1 mes la fecha de bloqueo de " + nombre + "?",
                        })}
                        {accion({
                            key: "vencimiento",
                            texto: "Fecha de bloqueo",
                            icon: <CalendarOutlined />,
                            paleta: "azul",
                            onClick: () => this.cambiarFechaVencimientoEmpresa(record._id, record.fechaVencimiento),
                        })}
                        {accion({
                            key: "usuarios",
                            texto: "Usuarios y contadores",
                            icon: <UserOutlined />,
                            paleta: "naranja",
                            onClick: () => this.cambiarUsuariosContadoresEmpresa(record._id, record.usuarios, record.contadores),
                        })}
                        {accion({
                            key: "soporte",
                            texto: "Soporte",
                            icon: <CustomerServiceOutlined />,
                            paleta: "cyan",
                            onClick: () => this.abrirAccesoSoporte(record),
                        })}
                    </div>
                    <div className="acciones-fila-grupo">
                        {accion({
                            key: "complementos",
                            texto: "Complementos",
                            icon: <AppstoreOutlined />,
                            paleta: "azul",
                            onClick: () => this.setState({ empresaComplementos: record }),
                        })}
                        {record.claude === true
                            ? [
                                accion({
                                    key: "paquete",
                                    texto: "Paquete de IA",
                                    icon: <SwapOutlined />,
                                    paleta: "morado",
                                    onClick: () => this.abrirPaqueteEmpresa(record),
                                }),
                                accion({
                                    key: "desactivarIa",
                                    texto: "Desactivar IA",
                                    icon: <RobotOutlined />,
                                    paleta: "lila",
                                    onClick: () => this.cambiarIaEmpresa(record._id, false),
                                    confirmar: "¿Estás seguro de desactivar la IA de " + nombre + "?",
                                }),
                            ]
                            : accion({
                                key: "activarIa",
                                texto: "Activar IA",
                                icon: <RobotOutlined />,
                                paleta: "morado",
                                onClick: () => this.abrirPaqueteEmpresa(record),
                            })}
                    </div>
                    <div className="acciones-fila-grupo acciones-fila-derecha">
                        {accion({
                            key: "deshabilitar",
                            texto: "Deshabilitar",
                            icon: <StopOutlined />,
                            paleta: "danger",
                            onClick: () => this.deshabilitarEmpresa(record._id),
                            confirmar: "¿Estás seguro de deshabilitar " + nombre + "? Los usuarios no podrán acceder a esta empresa.",
                        })}
                    </div>
                </div>
            );
        };

        const claseFila = (record) => {
            if (record.estado === 0) return "row-estado-cancelado";
            if (record.estado === 2) return "row-estado-deshabilitado";
            if (record.fechaVencimiento) {
                const diasRestantes = moment(record.fechaVencimiento).startOf('day').diff(moment().startOf('day'), 'days');
                if (diasRestantes < 0) return "alta-importancia";
                if (diasRestantes <= 7) return "media-importancia";
                return "baja-importancia";
            }
            return "";
        };

        const accionesBajoFila = (datos) => ({
            expandedRowRender: (record) => renderAcciones(record),
            expandedRowKeys: datos.map((record) => record._id),
            expandIconColumnIndex: -1,
            expandedRowClassName: (record) => `fila-acciones-empresa ${claseFila(record)}`,
        });

        return (
            <>
                <PageHeader
                    title="Empresas Biwo"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        this.state.pestana === "empresas" && <>
                            <ButtonItem type="primary" className="botonAgregar" icon={<PlusOutlined />} onClick={() => this.abrirAgregarEmpresa("completa")}>
                                Agregar empresa
                            </ButtonItem>
                            <ButtonItem type="primary" className="botonAgregar" icon={<PlusOutlined />} onClick={() => this.abrirAgregarEmpresa("basica")}>
                                Agregar empresa básica
                            </ButtonItem>
                            <ButtonItem type="primary" className="botonAgregar" icon={<PlusOutlined />} onClick={() => this.abrirAgregarEmpresa("basica2")}>
                                Agregar empresa básica 2
                            </ButtonItem>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Activas', value: 1 }, { label: "Canceladas", value: 2 }, { label: 'Vencidas', value: 3 }, { label: 'Todos', value: 4 }]}
                                        onChange={(value) => {
                                            this.setState({ valor: value }, () => {
                                                if (this.state.vistaAgrupada) {
                                                    this.fetchGruposAgrupados();
                                                } else if (this.tableRef) {
                                                    this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                                }
                                            });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            <ButtonItem
                                type="default"
                                morado
                                className="botonAgregar"
                                icon={<AppstoreOutlined />}
                                onClick={() => this.setState({ modalPaquetesIaVisible: true })}
                            >
                                Paquetes IA
                            </ButtonItem>
                            <ButtonItem
                                type={this.state.vistaAgrupada ? "primary" : "default"}
                                onClick={this.toggleVistaAgrupada}
                                className="botonAgregar"
                                icon={this.state.vistaAgrupada ? <UnorderedListOutlined /> : <GroupOutlined />}
                            >
                                {this.state.vistaAgrupada ? "Vista normal" : "Vista agrupada"}
                            </ButtonItem>
                        </>
                    }
                />
                <div className="card-background">
                <TabbedDynamicTable
                    defaultActiveKey={this.state.pestana}
                    onTabChange={(pestana) => this.setState({ pestana })}
                    tabs={[
                        {
                            key: "empresas",
                            label: "Empresas",
                            customContent: (
                <div className="tabla-empresas-biwo">
                    {this.state.vistaAgrupada ? (
                        <Table
                            dataSource={this.state.datosAgrupados}
                            rowKey="corporativo"
                            size="small"
                            loading={this.state.loading}
                            pagination={false}
                            columns={[
                                {
                                    title: "Corporativo",
                                    dataIndex: "corporativo",
                                    key: "corporativo",
                                },
                                {
                                    title: "Empresas",
                                    dataIndex: "count",
                                    key: "count",
                                    width: "10%",
                                    align: "center",
                                },
                            ]}
                            expandable={{
                                expandedRowRender: (grupo) => (
                                    <Table
                                        dataSource={grupo.empresas}
                                        rowKey="_id"
                                        size="small"
                                        pagination={false}
                                        columns={columns}
                                        expandable={accionesBajoFila(grupo.empresas)}
                                        scroll={{ x: "max-content" }}
                                        rowClassName={claseFila}
                                    />
                                ),
                            }}
                        />
                    ) : (
                        <TableItemDinamico
                            ref={(ref) => this.tableRef = ref}
                            onRef={(ref) => this.tableRef = ref}
                            totalRecords={this.state.totalRecords}
                            loading={this.state.loading}
                            onFetchData={this.consultarEmpresasBiwo.bind(this)}
                            anadirValorFiltro={this.state.valor}
                            size="small"
                            onlyMineFilter
                            dataSource={this.state.todasEmpresasBiwo}
                            columns={columns}
                            expandable={accionesBajoFila(this.state.todasEmpresasBiwo)}
                            scroll={{ x: "max-content" }}
                            filterStorageKey={"empresasBiwo"}
                            rowClassName={claseFila}
                            onRow={(record) => ({
                                onDoubleClick: () => {
                                    this.cambiarFechaVencimientoEmpresa(record._id, record.fechaVencimiento);
                                },
                            })}
                            setValor={(valor) => this.setState({ valor })}
                            valorDefault={4}
                        />
                    )}
                </div>
                            ),
                        },
                        { key: "resumen", label: "Resumen del negocio", customContent: <ResumenCobro /> },
                        { key: "conceptos", label: "Conceptos y paquetes", customContent: <CatalogoCobro vista="conceptos" /> },
                        { key: "combos", label: "Combos", customContent: <CatalogoCobro vista="combos" /> },
                        { key: "masters", label: "Cobro por master", customContent: <MastersCobro /> },
                        { key: "cobranza", label: "Cobranza", customContent: <CobranzaCobro /> },
                        { key: "configuracion", label: "Configuración de cobro", customContent: <ConfiguracionCobro /> },
                    ]}
                />
                </div>
                <AgregarEmpresa
                    visible={this.state.modalAgregarEmpresa === "completa"}
                    conMaster
                    tipoAlta="completa"
                    ruta="empresasBiwo/agregarEmpresaBiwo"
                    masters={this.state.mastersBiwo}
                    cerrarAgregarEmpresa={() => this.setState({ modalAgregarEmpresa: null }, () => this.refreshTable())}
                    titulo="Agregar empresa"
                />
                <AgregarEmpresaBasica
                    visible={this.state.modalAgregarEmpresa === "basica"}
                    conMaster
                    tipoAlta="basica"
                    ruta="empresasBiwo/agregarEmpresaBiwo"
                    masters={this.state.mastersBiwo}
                    cerrarAgregarEmpresaBasica={() => this.setState({ modalAgregarEmpresa: null }, () => this.refreshTable())}
                    titulo="Agregar empresa básica"
                />
                <AgregarEmpresaBasica2
                    visible={this.state.modalAgregarEmpresa === "basica2"}
                    conMaster
                    tipoAlta="basica2"
                    ruta="empresasBiwo/agregarEmpresaBiwo"
                    masters={this.state.mastersBiwo}
                    cerrarAgregarEmpresaBasica2={() => this.setState({ modalAgregarEmpresa: null }, () => this.refreshTable())}
                    titulo="Agregar empresa básica 2"
                />
                <ModalComplementosEmpresa
                    empresa={this.state.empresaComplementos}
                    onCancel={() => this.setState({ empresaComplementos: null }, () => this.refreshTable())}
                />
                <ModalItem
                    visible={this.state.modalCambiarFechaVencimientoVisible}
                    title="Cambiar fecha de bloqueo"
                    onCancel={this.cerrarModalCambiarFechaVencimiento}
                    footer={null}
                    destroyOnClose
                    spinning={this.state.loading}
                >
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRefVencimiento}
                            name="verOrdenCambiarFechaVencimiento"
                            layout
                            bottom={
                                <div style={{ display: "flex", justifyContent: "right" }}>
                                    <Space>
                                        <Popconfirm
                                            title={
                                                "Seguro que quieres cambiar la fecha de bloqueo de esta empresa"
                                            }
                                            onConfirm={() => this.confirmarCambiarFechaVencimiento()}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <ButtonItem type="primary">Confirmar</ButtonItem>
                                        </Popconfirm>
                                        <Popconfirm
                                            title={
                                                "Seguro que quieres cancelar esta orden de cambiar fecha de bloqueo"
                                            }
                                            onConfirm={() => this.cerrarModalCambiarFechaVencimiento()}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <ButtonItem type="primary" danger>
                                                Cancelar
                                            </ButtonItem>
                                        </Popconfirm>
                                    </Space>
                                </div>
                            }
                        >
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Fecha de bloqueo"
                                        name="fechaVencimiento"
                                        margin
                                        required
                                        initialValue={this.state.initialValueFechaVencimiento}
                                    >
                                        <DatePickerItem placeholder="Selecciona la nueva fecha de bloqueo" style={{ width: "100%" }} />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </ModalItem>
                <ModalItem
                    visible={this.state.modalCambiarUsuariosContadoresVisible}
                    title="Cambiar Usuarios y Contadores"
                    onCancel={this.cerrarModalCambiarUsuariosContadores}
                    footer={null}
                    destroyOnClose
                    spinning={this.state.loading}
                >
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRefUsuariosContadores}
                            name="verOrdenCambiarUsuariosContadores"
                            layout
                            bottom={
                                <div style={{ display: "flex", justifyContent: "right" }}>
                                    <Space>
                                        <Popconfirm
                                            title={
                                                "Seguro que quieres cambiar los usuarios y contadores de esta empresa"
                                            }
                                            onConfirm={() => this.confirmarCambiarUsuariosContadores()}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <ButtonItem type="primary">Confirmar</ButtonItem>
                                        </Popconfirm>
                                        <Popconfirm
                                            title={
                                                "Seguro que quieres cancelar esta orden de cambiar usuarios y contadores"
                                            }
                                            onConfirm={() => this.cerrarModalCambiarUsuariosContadores()}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <ButtonItem type="primary" danger>
                                                Cancelar
                                            </ButtonItem>
                                        </Popconfirm>
                                    </Space>
                                </div>
                            }
                        >
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Usuarios"
                                        name="usuarios"
                                        margin
                                        required
                                        initialValue={this.state.initialValueUsuarios}
                                    >
                                        <InputNumberItem placeholder="Ingrese el nuevo número de usuarios" />
                                    </FormItem>
                                    <FormItem
                                        label="Contadores"
                                        name="contadores"
                                        margin
                                        required
                                        initialValue={this.state.initialValueContadores}
                                    >
                                        <InputNumberItem placeholder="Ingrese el nuevo número de contadores" />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </ModalItem>
                <ModalItem
                    visible={this.state.modalAccesoSoporteVisible}
                    title={"Autorizar soporte — " + this.state.empresaAccesoSoporteNombre}
                    onCancel={this.cerrarAccesoSoporte}
                    footer={null}
                    destroyOnClose
                    spinning={false}
                    width={600}
                >
                    <Spin spinning={this.state.loadingAccesoSoporte}>
                        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 10 }}>
                            Todos los usuarios pueden levantar peticiones de soporte. Marca quiénes pueden
                            autorizarlas para que lleguen a Biwo. El usuario máster siempre puede.
                        </div>
                        <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 10, fontSize: 12 }}
                            message="La activación es del usuario, no de esta empresa"
                            description={
                                "Lo que marques o quites aquí aplica en TODAS las empresas del corporativo " +
                                "donde entre ese usuario."
                            }
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 8,
                                marginBottom: 8,
                            }}
                        >
                            <span style={{ fontSize: 12, fontWeight: 600 }}>
                                {this.state.idsAccesoSoporte.length} de{" "}
                                {this.state.usuariosAccesoSoporte.filter((u) => u.tipo !== 0).length} pueden autorizar
                            </span>
                            <Space>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    verde
                                    onClick={() => this.marcarTodosAccesoSoporte(true)}
                                >
                                    Marcar todos
                                </ButtonItem>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    danger
                                    onClick={() => this.marcarTodosAccesoSoporte(false)}
                                >
                                    Quitar todos
                                </ButtonItem>
                            </Space>
                        </div>
                        <div style={{ maxHeight: 380, overflowY: "auto", border: "1px solid #f0f0f0", borderRadius: 6 }}>
                            {this.state.usuariosAccesoSoporte.length === 0 ? (
                                <Empty
                                    description={this.state.loadingAccesoSoporte ? "Cargando..." : "Sin usuarios activos"}
                                    style={{ margin: "20px 0" }}
                                />
                            ) : (
                                this.state.usuariosAccesoSoporte.map((usuario) => {
                                    const id = usuario._id.toString();
                                    const esMaster = usuario.tipo === 0;
                                    return (
                                        <div
                                            key={id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: 8,
                                                padding: "8px 12px",
                                                borderBottom: "1px solid #f5f5f5",
                                            }}
                                        >
                                            <CheckItem
                                                checked={esMaster || this.state.idsAccesoSoporte.includes(id)}
                                                disabled={esMaster}
                                                onChange={(checked) => this.cambiarAccesoSoporte(id, checked)}
                                            >
                                                <span style={{ fontSize: 13 }}>{nombreDeUsuario(usuario)}</span>
                                                {usuario.correo && (
                                                    <span style={{ fontSize: 11, color: "#8c8c8c", marginLeft: 6 }}>
                                                        {usuario.correo}
                                                    </span>
                                                )}
                                            </CheckItem>
                                            {esMaster && <Tag color="blue">Máster · Siempre</Tag>}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                        <div style={{ display: "flex", justifyContent: "right", marginTop: 12 }}>
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    onClick={this.confirmarAccesoSoporte}
                                    disabled={this.state.usuariosAccesoSoporte.length === 0}
                                >
                                    Confirmar
                                </ButtonItem>
                                <ButtonItem type="primary" danger onClick={this.cerrarAccesoSoporte}>
                                    Cancelar
                                </ButtonItem>
                            </Space>
                        </div>
                    </Spin>
                </ModalItem>
                <ModalPaquetesIa
                    visible={this.state.modalPaquetesIaVisible}
                    onCancel={() => {
                        this.setState({ modalPaquetesIaVisible: false });
                        this.refreshTable();
                    }}
                />
                <ModalItem
                    visible={this.state.modalPaqueteEmpresaVisible}
                    title={(this.state.empresaPaquete?.claude ? "Cambiar paquete de IA — " : "Activar IA — ") + (this.state.empresaPaquete?.nombreCompleto || "")}
                    onCancel={this.cerrarPaqueteEmpresa}
                    footer={null}
                    destroyOnClose
                    spinning={false}
                    width={500}
                >
                    <Spin spinning={this.state.loading}>
                        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 10 }}>
                            Los límites del paquete aplican desde este momento. Solo se cuentan las consultas exitosas.
                        </div>
                        <SelectItem
                            placeholder="Selecciona el paquete de IA"
                            value={this.state.paqueteIaSeleccionado}
                            onChange={(paqueteIaSeleccionado) => this.setState({ paqueteIaSeleccionado })}
                            style={{ width: "100%" }}
                        >
                            {this.state.paquetesIaActivos.map((paquete) => (
                                <Select.Option key={paquete._id} value={paquete._id}>
                                    {`${paquete.nombre} — ${textoLimitesPaquete(paquete)} — ${textoPrecioPaquete(paquete)}`}
                                </Select.Option>
                            ))}
                        </SelectItem>
                        <div style={{ display: "flex", justifyContent: "right", marginTop: 12 }}>
                            <Space>
                                <ButtonItem type="primary" onClick={this.confirmarPaqueteEmpresa}>
                                    {this.state.empresaPaquete?.claude ? "Confirmar" : "Activar IA"}
                                </ButtonItem>
                                <ButtonItem type="primary" danger onClick={this.cerrarPaqueteEmpresa}>
                                    Cancelar
                                </ButtonItem>
                            </Space>
                        </div>
                    </Spin>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(EmpresasBiwo);
